import React, { Component } from 'react';
import { Field } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import moment from 'moment';
import _, { debounce } from 'lodash';

import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import { InputField } from '../Common/inputField';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter } from '../Common/dateFormat';
import checkPermission from '../Common/permissions';
import SpinnerButton from '../Common/SpinnerButton';
import { 
  ROOT_URL, companyCodeTitle, isOCM, isEKC, isLMH, isBRO, isSDR, isCRW, isOLG, isDAICHEONG, isCPG, isTQ, isVIP,
  isVAK, isHO, isJRC, isHMM, isCCW, isSC, isGGI
} from '../../actions/root_url';
import dateFilterRadios from '../Common/dateFilterRadios';
import { toFromDates, convertUtcDate } from '../Common/cleanDates';
import { getLocalStorageData } from '../../reducers/headerRedux';
import EmailContentModal from '../Sales/components/EmailContentModal';
import RefundModal from '../Sales/components/RefundModal';
import SerialNumDetailModal from '../../components/Dispatch/serialNumDetailModal'
import { isDst } from '../Common/NumberUtil';

class InventoryReturn extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,
        invoice: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        details: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        refundVisibility: false,
        emailContentModalVisibility: false,
        emailSubjectTemplate: '',
        emailContentTemplate: '',
        days: '7',
        fromDate: undefined,
        toDate: undefined,
        pdfPrinted: true,
        currentSerialNo: '',
        restockSerialNo: '',
        serialNumDetailModalVisibility: false,
        syncModalVisibility: false,
        syncMsg: '',
      };

      this.handleResize = this.handleResize.bind(this);
      this.checkAuthorize = this.checkAuthorize.bind(this);
      this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
      this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
      this.closeSyncVisibility = this.closeSyncVisibility.bind(this);
      this.setToDate = this.setToDate.bind(this);
      this.setFromDate = this.setFromDate.bind(this);
      this.handleDaysFilterChange = this.handleDaysFilterChange.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      window.addEventListener('resize', this.handleResize);
      const { fromDate, toDate, days } = this.state;
      // this.props.setDefaultDays("inventoryReturn");
      this.props.fetchInventoryReturns(fromDate, toDate, days);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        if (this.state.action === 'void') {
          this.voidReturn();
        }
      }
      if (nextProps.inventoryReturn && nextProps.inventoryReturn !== this.props.inventoryReturn) {
        const invoice = { ...this.state.invoice, selectedRows: [], rows: nextProps.inventoryReturn };
        this.setState({ invoice });
      }
      if (nextProps.inventoryReturnDetails && nextProps.inventoryReturnDetails !== this.props.inventoryReturnDetails) {
        const details = { ...this.state.details, rows: nextProps.inventoryReturnDetails.Sales_Return_Line };
        this.setState({ details });
      }
      if (nextProps.updated) {
        this.context.router.push('/inventoryReturn/');
      }
      if((isCCW || isGGI) && nextProps.selectedWarehouse !== this.props.selectedWarehouse) {
        const { fromDate, toDate, days } = this.state;
        this.props.fetchInventoryReturns(fromDate, toDate, days);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.selectedCompany !== this.props.selectedCompany) {
        const { fromDate, toDate, days } = this.state;
        // this.props.setDefaultDays("inventoryReturn");
        this.props.fetchInventoryReturns(fromDate, toDate, days);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    setToDate(e) {
      if (e < this.state.fromDate) {
        return;
      }
      this.setState({ toDate: e });
    }

    setFromDate(e) {
      if (e > this.state.toDate) {
        return;
      }
      this.setState({ fromDate: e });
    }

    setToRangeSearch = () => {
      this.setState({ days: '-1' });
    }

    handleDaysFilterChange(Days) {
      const { fromDate, toDate } = this.state;
      this.setState(
        { days: Days },
        () => { this.props.fetchInventoryReturns(fromDate, toDate, Days); 
          if (isHO || isJRC) {
            this.state.invoice.selectedRows = [];
            this.setState({ invoice })
        } },
      );
    }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeCheckAuthorize() {
      this.setState({ checkAuthorizeOpen: false });
    }

    closeSyncVisibility() {
      this.setState({ syncModalVisibility: false });
    }

    voidReturn() {
      this.props.voidReturn(this.state.invoice.selectedRows[0].SalesReturn_id);
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    shouldDisableVoidButton() {
      const { selectedRows } = this.state.invoice;
      if(selectedRows.length > 1) {
        return true;
      }
      if (isOCM) {
        if (selectedRows.length && checkPermission('set_released_sales_invoice')) return false;
      }
      if (isHMM) {
        if (selectedRows.length > 0 || !checkPermission('delete_sales_return')) {
          return false; // this will disable the void
        }
        return true;
      }
      if (selectedRows.length && selectedRows[0].IsFinalized) return true;
      if ((selectedRows.length > 0 &&
        selectedRows[0].ReturnStatus === 'Released' &&
        (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A')) ||
        !checkPermission('delete_sales_return')) {
        return false;
      }
      return true;
    }

    shouldDisableEditButton() {
      const { selectedRows } = this.state.invoice;
      if ((selectedRows.length > 0 &&
        selectedRows[0].ReturnStatus === 'Released' &&
        (selectedRows[0].CreditStatus === 'Credit' || selectedRows[0].CreditStatus === 'N/A')) ||
        !checkPermission('change_sales_return')) {
        return false;
      }
      return true;
    }

    // Once priceLevels are ready, reset state.
    updateRows(e) {
      e.preventDefault();
      this.props.editInventoryReturns(this.state.editedRows);
    }

    // formatDate(date) {
    //   if (!date) {
    //     return;
    //   }
    //   let formattedDate = `${date.getFullYear()}-`;
    //   formattedDate += `${date.getMonth() + 1}-`;
    //   if (date.getDate() < 10) {
    //     formattedDate += `0${date.getDate()}`;
    //   } else {
    //     formattedDate += date.getDate();
    //   }
    //   return formattedDate;
    // }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
      if (this.props.inventoryReturnIsLoading && !this.props.inventoryReturnError) {
        return <Spinner />;
      } // else if (this.props.inventoryReturnError) {
      //   return (
      //     <ContentWrapper>
      //       <div className="alert alert-danger">
      //         {JSON.stringify(this.props.inventoryReturnError)}
      //       </div>
      //     </ContentWrapper>
      //   );
      // }
      // else {
      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.invoice);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const invoice = Object.assign({}, this.state.invoice, { sortColumn, sortDirection });
        this.setState({
          invoice,
        });
      };

      // const handleFilterChange = (filter) => {
      //   this.setState({})
      //   const newFilters = Object.assign({}, this.state.invoice.filters);
      //   if (filter.filterTerm) {
      //     newFilters[filter.column.key] = filter;
      //   } else {
      //     delete newFilters[filter.column.key];
      //   }
      //   const invoice = { ...this.state.invoice, filters: newFilters };
      //   this.setState({ invoice });
      // };

      const handleFilterChange = debounce(
        (filter) => {
          // this.state.total = 0;
          this.state.invoice.rows = this.props.inventoryReturn;
          this.state.invoice.selectedRows = [];
          const newFilters = Object.assign({}, this.state.invoice.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          const invoice = { ...this.state.invoice, filters: newFilters };
          this.setState({ invoice });
        },
        200,
        { maxWait: 300 },
      );

      // const onRowsSelected = (rows) => {
      //   const allRows = this.state.invoice.rows;
      //   const newRows = getRows();
      //   // allRows.map((r) => {
      //   //   if (r === rows) {
      //   //     r.isSelected = true;
      //   //   }
      //   //   r.isSelected = false;
      //   // });
      //   let curRow = {};
      //   rows.map((r) => {
      //     curRow = newRows[r.rowIdx];
      //     newRows[r.rowIdx].isSelected = true;
      //   });
      //   let selectedRows = this.state.invoice.selectedRows;
      //   selectedRows = selectedRows.concat(rows.map(r => r.row));
      //   const invoice = { ...this.state.invoice, rows: allRows, selectedRows };
      //   this.setState({ invoice });
      //   this.props.fetchInventoryReturnsDetails(curRow.SalesReturn_id);
      // };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.invoice.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        const invoice = {
          ...this.state.invoice,
          rows: newRows,
          selectedRows,
        };
        this.setState({ invoice });
        if (rows && rows[0] && rows[0].row) {
          this.props.fetchInventoryReturnsDetails(rows[0].row.SalesReturn_id);
        }
      };

      // const onRowClick = (rowIdx, row) => {
      //   if (rowIdx !== -1) {
      //     const rows = getRows();
      //     rows.map((r) => {
      //       r.isSelected = false;
      //     });
      //     const selectedRows = [rows[rowIdx]];
      //     rows[rowIdx].isSelected = true;
  
      //     const invoice = { ...this.state.invoice, rows, selectedRows };
      //     this.setState({ invoice });
      //     if (row) {
      //       this.props.fetchInventoryReturnsDetails(row.SalesReturn_id);
      //     }        }
      // };

      // const onRowsDeselected = (rows) => {
      //   const newRows = this.state.invoice.rows;
      //   let curRow = false;
      //   const selectedRows = [];
      //   rows.map((r) => {
      //     curRow = newRows[r.rowIdx];
      //     newRows[r.rowIdx].isSelected = false;
      //   });
      //   _.forEach(newRows, row => {
      //     if (row.isSelected) {
      //       selectedRows.push(row);
      //     }
      //   });
      //   this.setState({ isSelected: false, curRow });
      //   const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
      //   this.setState({ invoice });
      // };
      const onRowsDeselected = (rows) => {
        const newRows = this.state.invoice.rows;
        const selectedRows = [...this.state.invoice.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          const rowIndex = selectedRows.findIndex(row => r.row.SalesReturn_id == row.SalesReturn_id);
          selectedRows.splice(rowIndex, 1);
        });
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };

      const columns = [
        {
          key: 'SRNum',
          name: <Translate value="rtn_no" />,
          resizable: true,
          width: 150,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Deliver_Customer_Num',
          name: <Translate value="cust_no" />,
          resizable: true,
          width: 130,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Deliver_Customer_Name',
          name: <Translate value="cust_name" />,
          resizable: true,
          width: 180,
          sortable: true,
          filterable: true,
        },
        {
          key: 'IsFinalized',
          name: <Translate value="is_finalized" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: (props) => {
            return (
              <div>{props.value ? 'yes': 'no'}</div>
            )
          }
        },
        ...(isCPG || isVIP || isLMH || isBRO || isTQ) ? [{
          key: 'SyncStatus',
          name: <Translate value="qb_sync" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
        }] : [],
        ...(isCPG || isVIP || isLMH || isBRO || isTQ) ? [{
          key: 'QBError',
          name: <Translate value="qb_msg" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
        getRowMetaData: (row) => row,
          formatter: ({dependentValues}) => {
            return (
              <div style={{cursor: 'pointer'}} onClick={() => this.setState({syncModalVisibility: true, syncMsg: dependentValues.QBError})}>{(dependentValues.SyncStatus !== 'Synced') ? dependentValues.QBError : ''}</div>
            )
          }
        }] : [],
        {
          key: 'PostingDate',
          name: <Translate value="return_date" />,
          resizable: true,
          width: 126,
          sortable: true,
          filterable: true,
          formatter: DateFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'ReturnStatus',
          name: <Translate value="return_status" />,
          resizable: true,
          width: 90,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockStatus',
          name: <Translate value="restock_status" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
        },
        {
          key: 'CreditStatus',
          name: <Translate value="credit_status" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="final" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'UnusedCredit',
          name: <Translate value="balance" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        ...isDAICHEONG ? [{
          key: 'Sales_User_Name',
          name: <Translate value="sales" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
        }] : [],
        ...(isSDR || isCRW || isSC) ? [{
          key: "PaymentType",
          name: <Translate value="payment_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 130,
        }] : [],
        ...(isSDR) ? [{
          key: "CloverLastFour",
          name: <Translate value="last_4" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }] : [],
        {
          key: 'Note',
          name: <Translate value="notation" />,
          resizable: true,
          width: 200,
          sortable: true,
          filterable: true,
        },
      ];
      if (isOLG) {
        const customerNumIndex = columns.findIndex(column => column.key === 'Deliver_Customer_Num');
        if (customerNumIndex !== -1) {
          columns.splice(customerNumIndex + 1, 0, {
            key: 'Order_Person',
            name: <Translate value="order_person" />,
            resizable: true,
            width: 130,
            sortable: true,
            filterable: true,
          });
        }
      }

      let cTemp = [];
      if (this.state.invoice && this.state.invoice.rows && this.state.invoice.rows.length > 0) {
        this.state.invoice.rows.map((r,i) => {
          if (r.SyncStatus === 0) {
            cTemp.push({...r, SyncStatus: 'Unsynced'});
          } else if (r.SyncStatus === 1) {
            cTemp.push({...r, SyncStatus: 'Synced'});
          } else if (r.SyncStatus === 2) {
            cTemp.push({...r, SyncStatus: 'Failed'});
          } else {
            cTemp.push({...r});
          }
        });
        this.state.invoice.rows = cTemp;
      }

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%', height: '300px' }} id="InventoryReturn-dataGrid1">
              <ReactDataGrid
                rowKey="SalesReturnLine_id"
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                headerRowHeight={45}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={250}
                rowHeight={25}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                // onRowClick={onRowClick}
              />
            </div>
          </Col>
        </Row>
      );
      // }
    }

    renderDetails() {
      if (this.props.inventoryReturnDetailsIsLoading && !this.props.inventoryReturnDetailsError) {
        return <Spinner />;
      } // else if (this.props.inventoryReturnDetailsError) {
      //   return (
      //     <ContentWrapper>
      //       <div className="alert alert-danger">
      //         {JSON.stringify(this.props.inventoryReturnDetailsError)}
      //       </div>
      //     </ContentWrapper>
      //   );
      // }
      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.details);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const details = Object.assign({}, this.state.details, { sortColumn, sortDirection });
        this.setState({
          details,
        });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.details.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const details = { ...this.state.details, filters: newFilters };
        this.setState({ details });
      };

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return (
              <span>
                {this.props.value}
                <label className="label label-success">
                  <Translate value="non_fixed" />
                </label>
              </span>
            );
          }
          return (
            <span>
              {this.props.value}
            </span>
          );
        },
      });

      // Column difinition

      const DateFormatter = React.createClass({
        render() {
          return (
            <span>
              {moment.utc(this.props.dependentValues.CreateTime).local().format('YYYY-MM-DD')}
            </span>
          );
        },
      });

      const columns = [
        {
          key: "RefNum",
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          isHide: (isEKC || isLMH || isBRO || isSDR || isCRW || isSC),
        },
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          width: 280,
          sortable: true,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          width: 130,
          sortable: true,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'ReturnQuantity',
          name: <Translate value="return_qty" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: IsFixedFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'ReturnWeight',
          name: <Translate value="rtn_wt" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          isHide: (isEKC || isLMH || isBRO || isSDR || isCRW || isSC),
        },
        {
          key: 'ReturnTotalPrice',
          name: <Translate value="total" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        },
        {
          key: 'ReturnReason',
          name: <Translate value="return_reason" />,
          resizable: true,
          width: 140,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockQuantity',
          name: <Translate value="restock_qty" />,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        },
        {
          key: 'RestockWeight',
          name: <Translate value="restock_wt" />,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        },
        ...isVAK ? [{
          key: 'Batch_Num',
          name: <Translate value="batch_no" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'SerialNum',
          name: <Translate value="serial_no" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
          formatter: (props, dependentValues) => {
            return props.dependentValues.SerialNum ? (
              <div style={{ textAlign: 'center', color: '#0077c5', fontWeight: 600, cursor: 'pointer' }} onClick={event => {
                this.setState({
                  currentSerialNo: props.dependentValues.SerialNum,
                  restockSerialNo: props.dependentValues.SerialNum_Restock,
                  serialNumDetailModalVisibility: true,
                });
              }}><Translate value="detail" /></div>
            ) : null
          },
          getRowMetaData: (row) => row,
        }] : [],
      ].filter(item => !item.isHide);

      return (
        <Row>
          <Col sm={12}>
            <div style={{ maxWidth: '100%', height: '300px' }} id="InventoryReturn-dataGrid2">
              <ReactDataGrid
                rowKey="SalesReturnLine_id"
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={250}
                rowHeight={25}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderPrintButton() {
      const { invoice: { selectedRows } } = this.state;
      const disabled = selectedRows && selectedRows.length !== 1;
      const { SalesReturn_id: salesReturnID } = selectedRows && selectedRows.length === 1 && selectedRows[0];
      const token = `Bearer=${localStorage.getItem('token')}`;
      const url = `${ROOT_URL}v1/sale/printreturn/${salesReturnID}?${token}`;
      const onClick = () => {
        this.state.pdfPrinted = false;
        this.props.fetchSalesReturnPDF(salesReturnID);
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          // href={url}
          onClick={onClick}
          disabled={disabled}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
      );
    }

    renderNoPriceButton() {
      const { invoice: { selectedRows } } = this.state;
      const disabled = selectedRows && selectedRows.length !== 1;
      const { SalesReturn_id: salesReturnID } = selectedRows && selectedRows.length === 1 && selectedRows[0];
      const token = `Bearer=${localStorage.getItem('token')}`;
      let url = `${ROOT_URL}v1/sale/printreturn_no_price/${salesReturnID}?${token}`;
      if(isOLG) {
        let sq = new Date().getTimezoneOffset();
        let time = -sq / 60;
        if(sq > 0 && isDst()) {
          sq+=60;
          let zone = -sq / 60;
          url += `&time_zone=${zone}&time_diff=${time}`;
        } else {
          url += `&time_zone=${(time)}&time_diff=${time}`;
        }
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={disabled}
        >
          <em className="fa fa-print" /><Translate value="no_price" />
        </Button>
      );
    }

    renderExportButton = () => {
      const { fromDate, toDate, invoice } = this.state;
      const { selectedCompany, selectedWarehouse } = this.props;
      const dates = toFromDates(this.state.days, fromDate, toDate);
      const token = `Bearer=${localStorage.getItem('token')}`;
      const Company_id = selectedCompany ? selectedCompany.value : null;
      const warehouse_id = selectedWarehouse ? selectedWarehouse.value : null
      let url = `${ROOT_URL}v1/sale/sales_return/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&format=csv&${token}&Company_id=${Company_id}`;
      let selectedRowsArr = [];
      invoice.selectedRows.map(item => {
        selectedRowsArr.push(item.SalesReturn_id)
      })
      if ((isHO || isJRC) && selectedRowsArr.length) {
        url += `&ids=${selectedRowsArr.join(',')}`
      }
      if (isGGI) {
        url += `&warehouse_id=${warehouse_id}`
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={false}
        >
          <em className="fa fa-print" /><Translate value="export" />
        </Button>
      );
    }

    renderExportLineDetailButton = () => {
      const { fromDate, toDate, invoice } = this.state;
      const { selectedCompany, selectedWarehouse } = this.props;
      const dates = toFromDates(this.state.days, fromDate, toDate);
      const token = `Bearer=${localStorage.getItem('token')}`;
      const Company_id = selectedCompany ? selectedCompany.value : null;
      const warehouse_id = selectedWarehouse ? selectedWarehouse.value : null
      let url = `${ROOT_URL}v1/sale/sales_return_lines?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&format=csv&${token}&Company_id=${Company_id}`;
      let selectedRowsArr = [];
      invoice.selectedRows.map(item => {
        selectedRowsArr.push(item.SalesReturn_id)
      })
      if ((isHO || isJRC) && selectedRowsArr.length) {
        url += `&ids=${selectedRowsArr.join(',')}`
      }
      if (isGGI) {
        url += `&warehouse_id=${warehouse_id}`
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          disabled={false}
        >
          <em className="fa fa-print" /><Translate value="export_line_detail" />
        </Button>
      );
    }

    renderSyncToQB = () => {
      const {
        selectedRows,
      } = this.state.invoice
      const sales_return_ids = _.map(selectedRows, row => row.SalesReturn_id).join(',');
      const enabled = () => {
        if (checkPermission("set_released_sales_invoice") && selectedRows.length) {
          return true;
        }
        return false;
      }
      return(
        <SpinnerButton
          bsStyle="primary"
          disabled={!enabled()}
          translation={<Translate value="sync_to_QB" />}
          loading={this.props.syncQbLoading}
          onClick={() => {
            this.props.syncSalesReturnsToQB(sales_return_ids);
          }}
        />
      )
    }

    renderRefund = () => {
      const { selectedRows } = this.state.invoice;
      const enabled = () => {
        if (selectedRows && selectedRows.length === 1 && selectedRows[0].SRNum.substr(selectedRows[0].SRNum.length - 1) !== 'C' && selectedRows[0].CreditStatus !== 'Used') {
          return true;
        }
        return false
      }
      // const receive_ids = _.map(selectedRows, row => row.WarehouseReceive_id).join(',');
      return (
        <Button
        bsStyle="primary"
        type="button"
        onClick={() => {
          this.setState({
            refundVisibility: true,
          });
          // this.props.syncReceiveHistoryToQuickBook(receive_ids);
        }}
        disabled={!enabled()}
      >
        <Translate value="refund" />
      </Button>
      )
    }

    handleRefundClose = () => {
      this.setState({
        refundVisibility: false,
      });
    }

    handleRefundFinish = () => {
      this.props.fetchInventoryReturns(this.state.fromDate, this.state.toDate, this.state.days);
      // this.setState({
      //   refundVisibility: false,
      // });
    }

    renderEmailButton = () => {
      if (!isOCM) {
        return;
      }
      const {
        selectedRows,
      } = this.state.invoice
      return(
        <Button
          bsStyle="primary"
          type="button"
          disabled={selectedRows.length !== 1}
          onClick={() => {
            this.setState({
              emailSubjectTemplate: this.genSubjectTemplate(),
              emailContentTemplate: this.genContentTemplate(),
              emailContentModalVisibility: true
            })
          }}
        >
          <Translate value="email" />
        </Button>
      )
    }

  genSubjectTemplate = () => {
    if(isOCM) {
      const row = this.state.invoice.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      if(row) {
        const srNum = row.SRNum;
        return `Sales Return ${srNum} from ${activeCompany.toUpperCase()}`
      }
    }
    return ''
  }

  genContentTemplate = () => {
    if(isOCM) {
      const row = this.state.invoice.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      const srNum = row.SRNum;
      const finalPrice = row.FinalPrice;
      return `Dear Customer:

Your Sales Return - ${srNum} for ${finalPrice} is attached. Please check it at your earliest convenience.
Thank you for your business - we appreciate it very much.

Sincerely,
${activeCompany.toUpperCase()}`
    }
    return ''
  }
  handleEmailContentConfirm = (subject, content) => {
    const row = this.state.invoice.selectedRows[0];
    if(row) {
      this.props.emailSR(row.SalesReturn_id, subject, content);
      this.handleEmailContentClose();
    }
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

    checkIfSelectedCantBeFinalized = () => {
      const {
        selectedRows,
      } = this.state.invoice;
      let cantBeFinallized = false;
      if (!selectedRows.length) return true;
      selectedRows.forEach(row => {
        if (row.IsFinalized || row.ReturnStatus == 'Void') {
          // alert(`${row.PRNum} has already been finalized`);
          cantBeFinallized = true;
        }
      })

      return cantBeFinallized;
    };

    finalizeSelectedSaleReturns = () => {
      const { invoice: { selectedRows } } = this.state;
      const ids = selectedRows.map(r => r.SalesReturn_id);
      const success = () => {
        alert('success')
        this.refreshList();
      };
      const failed = () => {
        alert('failed')
      };
      this.props.finalizeSalesReturns(ids.join(','), success, failed);
    }

    refreshList = () => {
      this.setState({
        invoice: {
          ...this.state.invoice,
          selectedRows: [],
        }
      })
      this.props.fetchInventoryReturns(this.state.fromDate, this.state.toDate, this.state.days);
    }

    selectedHasBeenFinalized = () => {
      const {
        invoice: {
          selectedRows
        }
      } = this.state;
      if (selectedRows.length < 1) return true;
      let finalized = false;
      if (selectedRows[0] && selectedRows[0].IsFinalized) {
        if (isOCM && checkPermission('set_released_sales_invoice')) {
          return false;
        }
        finalized = true;
      }
      return finalized;
    }

    onPDFLoaded = (id) => {
      if (!this.state.pdfPrinted) {
        const iframe = document.getElementById(id);
        const iframeWindow = iframe.contentWindow || iframe;
        iframe.focus();
        iframeWindow.print();
        this.state.pdfPrinted = true
      }
    }

    renderPDFIframe = () => {
      let file = '';
      if (this.props.pdfFile) {
        file = window.URL.createObjectURL(this.props.pdfFile)
      }
      return (
        <iframe
          id={"ramdomId"}
          name={"ramdomId"}
          style={{ display: 'none' }}
          onLoad={() => this.onPDFLoaded("ramdomId")}
          src={file}
        />
      )
    }

  handleSerialNumDetailModalCancel = () => {
    this.setState({
      serialNumDetailModalVisibility: false,
    });
  }

    render() {
      const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
      };
      let serialDetailDialogStyle = {
        width: '500px',
        height: '500px',
        top: '45%',
        marginLeft: '-10%',
      };
      let searchNoStyle={'float': 'left', width: '190px', 'padding-left': '10px', marginRight: '10px'}
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="returns" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="sales_return" />
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* <div className="content-heading"><Translate value="inventory" /></div> */}
          <Grid id="inventory-return">
            {/* <h1><Translate value="sales_return" /></h1> */}
            <Row>
              <Col sm={12}>
                <Panel id="date-range-picker" className="form-horizontal">
                  <Row>
                    <Col xs={1}>
                      <h3 className="filter-title text-nowrap"><Translate value="return_date" /><span className="colon">:</span></h3>
                    </Col>
                    <Col xs={11}>
                      {
                        dateFilterRadios({
                          handleOnClick: this.handleDaysFilterChange,
                          setFromDate: this.setFromDate,
                          setToDate: this.setToDate,
                          setToRangeSearch: this.setToRangeSearch,
                          FromDate: this.state.fromDate,
                          ToDate: this.state.toDate,
                          Days: this.state.days,
                        })
                      }
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix" style={{ height: '350px' }}>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="warning"
                      type="submit"
                      onClick={() => {
                        this.context.router.push(`/customerReturn/${this.state.invoice.selectedRows[0].SalesReturn_id}`);
                      }}
                      disabled={this.selectedHasBeenFinalized() || this.state.invoice.selectedRows.length !== 1}
                    >
                      <em className="fa fa-edit" /><Translate value="edit" />
                    </Button>
                    <Button
                      bsStyle="primary"
                      type="submit"
                      onClick={() => {
                        // this.props.completeReturn(this.state.invoice.selectedRows[0].SalesReturn_id)
                        this.context.router.push(`/restockReturn/${this.state.invoice.selectedRows[0].SalesReturn_id}`);
                      }}
                      disabled={this.state.invoice.selectedRows.length !== 1 || this.state.invoice.selectedRows[0].RestockStatus !== 'Restock' || !checkPermission('change_sales_return')}
                    >
                      <em className="fa fa-plus" /><Translate value="restock" />
                    </Button>
                    <Button
                      bsStyle="primary"
                      type="submit"
                      disabled={this.checkIfSelectedCantBeFinalized()}
                      onClick={() => {
                        this.finalizeSelectedSaleReturns();
                      }}
                    >
                      <em className="fa fa-file" /><Translate value="finalize" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="submit"
                      onClick={() => { this.openCheckAuthorize('void'); }}
                      disabled={this.shouldDisableVoidButton()}
                    >
                      <em className="fa fa-trash" /><Translate value="void" />
                    </Button>
                    { this.renderPrintButton() }
                    { this.renderNoPriceButton() }
                    { this.renderExportButton() }
                    { this.renderExportLineDetailButton() }
                    {!isLMH && this.renderSyncToQB()}
                    { (isLMH && checkPermission('qb_sync_all')) && this.renderSyncToQB()}
                    {(isSDR || isBRO) && this.renderRefund()}
                    {this.renderEmailButton()}
                    { isVAK && <span> 
                      <div style={searchNoStyle}>
                        <Field name="SearchNum" component={InputField} placeholder={ I18n.t('rtn_or_serial_no_search')} />
                      </div>    
                      <Button bsStyle="primary" style={{padding: "1px 6px"}} onClick={() => { const { fromDate, toDate, days } = this.state; this.props.fetchInventoryReturns(fromDate, toDate, days, this.props.SearchNum) }}>
                        <em className="fa fa-search" style={{fontSize: '14px'}}/>
                      </Button>
                    </span> }
                  </ButtonToolbar>
                  {this.renderTable() }
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix" style={{ height: '360px' }}>
                  {this.renderDetails() }
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col sm={2}>
                { this.props.inventoryReturnIsEditing && <div><Spinner /><Translate value="uploading" /></div> }
                { this.props.inventoryReturnEdited && <div className="alert alert-success"><Translate value="saved" /></div>}
                { this.props.editInventoryReturnError && <div className="alert alert-danger marginTopStyle" >{this.props.editInventoryReturnError}</div> }
              </Col>
            </Row>
          </Grid>
          {this.renderPDFIframe()}
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.checkAuthorizeOpen}
            onCloseClicked={this.closeCheckAuthorize}
          >
            <ConfirmActionModal
              case="confirmPassword"
              closeC={this.checkAuthorize}
              checkPasswordFailure={this.props.checkPasswordFailure}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.syncModalVisibility}
            onCloseClicked={this.closeSyncVisibility}
          >
           <p style={{fontSize: '13px'}}>
              {this.state.syncMsg}
           </p>
          </SkyLightStateless>
          <EmailContentModal
            visible={this.state.emailContentModalVisibility}
            subject={this.state.emailSubjectTemplate}
            content={this.state.emailContentTemplate}
            onConfirm={this.handleEmailContentConfirm}
            onClose={this.handleEmailContentClose}
          />
          <RefundModal
            visible={this.state.refundVisibility}
            selectedRows={this.state.invoice.selectedRows}
            // subject={this.state.emailSubjectTemplate}
            // content={this.state.emailContentTemplate}
            onFinish={this.handleRefundFinish}
            onClose={this.handleRefundClose}
          />
          <SkyLightStateless
            dialogStyles={serialDetailDialogStyle}
            isVisible={this.state.serialNumDetailModalVisibility}
            onCloseClicked={() => { this.handleSerialNumDetailModalCancel() }}
            title={<Translate value="view_serial_num" />}>
            <SerialNumDetailModal
              closeC={this.handleSerialNumDetailModalCancel}
              currentSerialNo = {this.state.currentSerialNo}
              restockSerialNo = {this.state.restockSerialNo}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

export default InventoryReturn;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/inventoryReturn.jsx